export const homeTr = {
  // Hero section
  heroTitle: "O Yapabilir. O Yapacak. O Yaptı.",
  heroSubtitle: "Dayanıklılıktan doğan, 'yapamazsın' denilen her kadın için inşa edilmiş bir hareket.",
  heroButton: "Topluluğumuza Katılın",
  
  // Story section
  storyTitle: "Mücadeleden Güce",
  storyText1: "SheCan, zorlukların üstesinden gelme yolculuğumdan doğdu. Sayısız engelle karşılaşan ve sayamayacağım kadar çok 'yapamazsın' duyan bir kadın olarak, onlara yanıldıklarını kanıtlamaya karar verdim.",
  storyText2: "Bu hareket, küçümsenen, gözden kaçırılan veya hayallerinin çok büyük olduğu söylenen her kadın içindir. Birlikte, anlatıyı yeniden yazıyoruz.",
  storyButton: "Hikayemi Okuyun",
  
  // Community section
  communityTitle: "Durdurulamaz Kadınlardan Oluşan Bir Topluluğa Katılın",
  communitySubtitle: "Bağlanın, büyüyün ve birlikte gelişin",
  communityFeature1: "Destekleyici Ağ",
  communityFeature1Text: "Yolculuğunuzu anlayan benzer düşünen kadınlarla bağlantı kurun",
  communityFeature2: "Özel Etkinlikler",
  communityFeature2Text: "Atölyelere, web seminerlerine ve ağ oluşturma fırsatlarına erişin",
  communityFeature3: "Kaynaklar ve Araçlar",
  communityFeature3Text: "Hedeflerinize ulaşmanıza yardımcı olacak pratik kaynaklar edinin",
  communityButton: "Topluluğu Keşfedin",
  
  // Featured Products
  productsTitle: "Yolculuğunuzu Güçlendirin",
  productsSubtitle: "Sizi ilham vermek ve desteklemek için seçilmiş ürünler",
  
  // Testimonials
  testimonialsTitle: "Dönüşüm Hikayeleri",
  testimonial1: "SheCan bana kendi işimi kurma cesareti verdi. Topluluk desteği inanılmaz!",
  testimonial1Author: "Sarah Johnson",
  testimonial1Role: "Girişimci",
  testimonial2: "Sesimi ve kabilemi burada buldum. Bu hareket hayatımı değiştirdi.",
  testimonial2Author: "Maria Garcia",
  testimonial2Role: "Yazar",
  testimonial3: "Kaynaklar ve destek, kariyer geçişimi güvenle yönetmeme yardımcı oldu.",
  testimonial3Author: "Emily Chen",
  testimonial3Role: "Kariyer Koçu"
};

export default homeTr;
